export const REQUIRED_DOCUMENTS_TABLE_HEADERS = [
  {
    dataKey: "form-identity"
  },
  {
    dataKey: "e-ktp",
    tooltip: "e-ktp-tooltip"
  },
  {
    dataKey: "letter-of-attorney",
    tooltip: "letter-of-attorney-tooltip"
  },
  {
    dataKey: "npwp",
    tooltip: "npwp-tooltip"
  },
  {
    dataKey: "license-number"
  },
  {
    dataKey: "business-id-number"
  },
  {
    dataKey: "sk-kemenkumham",
    tooltip: "sk-kemenkumham-tooltip"
  },
  {
    dataKey: "other-documents"
  }
];

export const REQUIRED_DOCUMENTS_DATA = [
  {
    "col-1": "cv",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": true,
    "col-6": true,
    "col-7": true,
    "col-8": false
  },
  {
    "col-1": "firma",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": true,
    "col-6": true,
    "col-7": true,
    "col-8": false
  },
  {
    "col-1": "yayasan",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": true,
    "col-6": "yayasan-nib",
    "col-7": true,
    "col-8": false
  },
  {
    "col-1": "pt",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": true,
    "col-6": true,
    "col-7": true,
    "col-8": false
  },
  {
    "col-1": "koperasi",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": true,
    "col-6": true,
    "col-7": true,
    "col-8": false
  },
  {
    "col-1": "umkm",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": false,
    "col-6": "umkm-nib",
    "col-7": false,
    "col-8": "umkm-other-docs"
  },
  {
    "col-1": "kementerian",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": false,
    "col-6": false,
    "col-7": false,
    "col-8": "kementrian-other-docs"
  },
  {
    "col-1": "lembaga-pemerintahan",
    "col-2": true,
    "col-3": true,
    "col-4": true,
    "col-5": false,
    "col-6": false,
    "col-7": false,
    "col-8": ["lembaga-pemerintahan-other-doc-1", "lembaga-pemerintahan-other-doc-2"]
  }
];
